<template>
  <InputPicker
    button-label="Insert emoji"
    button-icon="grin"
    button-fill="far"
    :textarea="textarea"
    :items="emojis"
    @input="$emit('input', $event)"
    @cancelTrigger="(refocus) => $emit('cancelTrigger', refocus)"
  >
    <template #default="{items, select, insertSelected}">
      <div v-for="(emojiGroup, category) in items" :key="category">
        <h5 class="mt-3">
          {{ category }}
        </h5>
        <div class="emojis">
          <button
            v-for="(emoji, emojiName) in emojiGroup"
            :key="emojiName"
            class="btn btn-light btn-sm all-emoji"
            :title="emojiName"
            type="button"
            @click="selectAndInsert(emoji, select, insertSelected)"
          >
            {{ emoji }}
          </button>
        </div>
      </div>
    </template>
  </InputPicker>
</template>

<script>
import InputPicker from "@/FormWidgets/WidgetInputArea/components/InputPicker.vue";
import emojis from "@/FormWidgets/WidgetInputArea/components/emojis.js";

export default {
  name: "EmojiPicker" ,
  components: {InputPicker},
  // Vue 3:
  // emits: ['input', 'cancelTrigger'], // Even without a typed trigger, @cancelTrigger refocuses the textarea
  props: {
    textarea: Function,
  },
  computed: {
    emojis() {
      return emojis
    },
  },
  methods: {
    selectAndInsert: function(emoji, select, insertSelected) {
      select(emoji);
      insertSelected();
    }
  }
}
</script>

<style scoped>
.all-emoji {
  font-size: 1.8rem;
}
</style>
